module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "slot": "header",
      "dark": ""
    },
    slot: "header"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.editing) ? _c('span', [_vm._v("Editing")]) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [(_vm.canWrite(_vm.policiesDoc)) ? _c('v-list-item', [_c('v-list-item-title', [_c('v-switch', {
    staticClass: "ml-4",
    attrs: {
      "label": "Edit Mode"
    },
    model: {
      value: (_vm.editing),
      callback: function($$v) {
        _vm.editing = $$v
      },
      expression: "editing"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.canWrite(_vm.policiesDoc)) ? _c('v-list-item', {
    on: {
      "click": _vm.downloadBackups
    }
  }, [_c('v-list-item-title', [_vm._v("Download Policy Backup")])], 1) : _vm._e(), _vm._v(" "), (_vm.canWrite(_vm.policiesDoc) && _vm.editing && _vm.selectedRequirement) ? _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.addSpecialChecks('statements')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Add statement checks")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.startCreation()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Start Creation")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "white-background",
    staticStyle: {
      "position": "relative",
      "display": "flex",
      "flex-direction": "column",
      "height": "100%"
    },
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_c('ListList', {
    attrs: {
      "items": _vm.lenders
    },
    on: {
      "click": _vm.resetPolicy
    },
    model: {
      value: (_vm.lender),
      callback: function($$v) {
        _vm.lender = $$v
      },
      expression: "lender"
    }
  }, [_c('v-list-item', {
    attrs: {
      "slot": "top",
      "input-value": false
    },
    on: {
      "click": function($event) {
        _vm.lender = null
      }
    },
    slot: "top"
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("General Requirements")])], 1)], 1), _vm._v(" "), (_vm.canWrite(_vm.lendersDoc) && _vm.editing) ? _c('v-list-item', {
    attrs: {
      "slot": "bottom",
      "input-value": false
    },
    on: {
      "click": _vm.addLender
    },
    slot: "bottom"
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add a Lender")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex",
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin": "6px 20px"
    },
    attrs: {
      "filled": "",
      "dense": "",
      "rounded": "",
      "placeholder": "Search...",
      "hide-details": ""
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return [(_vm.filterPolicies(category.policies).length) ? _c('div', {
      key: category.name,
      staticClass: "white ma-5 elevation-3",
      staticStyle: {
        "position": "relative",
        "padding": "60px 40px 20px 40px"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "position": "absolute",
        "top": "0",
        "left": "0",
        "right": "0",
        "font-size": "16px",
        "text-align": "center",
        "letter-spacing": "3px",
        "padding": "8px",
        "background-color": "#eee",
        "color": "#888",
        "text-transform": "uppercase"
      }
    }, [_vm._v("\n            " + _vm._s(category.name) + "\n            "), (_vm.editing) ? _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "grey"
            }
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.addPolicy(category)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add another " + _vm._s(category.name) + " policy")])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _vm._l((_vm.filterPolicies(category.policies)), function(policy) {
      return _c('div', {
        key: policy._id,
        staticClass: "mb-6 policy-container",
        on: {
          "click": function($event) {
            _vm.selectedPolicy = policy
          }
        }
      }, [_c('div', {
        staticStyle: {
          "margin-bottom": "0px",
          "color": "#666",
          "font-weight": "bold"
        }
      }, [_c('div', {
        staticClass: "policy-box",
        staticStyle: {
          "display": "inline"
        },
        on: {
          "click": function($event) {
            _vm.selectedRequirement = null
          }
        }
      }, [_c('EditableText', {
        attrs: {
          "plain": "",
          "read-only": !_vm.editing,
          "inline": ""
        },
        model: {
          value: (policy.name),
          callback: function($$v) {
            _vm.$set(policy, "name", $$v)
          },
          expression: "policy.name"
        }
      })], 1), _vm._v(" "), (_vm.editing) ? _c('div', {
        staticStyle: {
          "display": "inline",
          "margin-left": "-6px"
        }
      }, [_c('v-menu', {
        attrs: {
          "offset-y": "",
          "left": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-icon', _vm._g({
              attrs: {
                "color": "grey lighten-2"
              }
            }, on), [_vm._v("more_vert")])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.addPolicy(category)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Add another " + _vm._s(category.name) + " policy")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.deletePolicy(policy, category)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Delete policy")])], 1), _vm._v(" "), (!policy._stipulation._default) ? _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.revertToGeneric(policy)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Revert " + _vm._s(_vm.lender.name) + " back to generic policy")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), (policy._stipulation) ? _vm._l((policy._stipulation.options), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex,
          staticClass: "options-section",
          class: {
            specific: !policy._stipulation._default
          }
        }, [(optionIndex != 0) ? _c('div', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "padding": "3px"
          }
        }, [_vm._v("   (OR)")]) : _vm._e(), _vm._v(" "), _vm._l((option.requirements), function(requirement, requirementIndex) {
          return _c('div', {
            key: requirementIndex,
            staticStyle: {
              "display": "inline"
            }
          }, [(requirementIndex != 0) ? _c('div', {
            staticStyle: {
              "display": "inline",
              "font-size": "14px",
              "font-weight": "bold",
              "padding": "3px 0 3px 3px"
            }
          }, [_vm._v("AND")]) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "hoverable requirement-box",
            class: {
              hilight: _vm.isRequirementHilighted(requirement)
            },
            staticStyle: {
              "display": "inline"
            },
            on: {
              "click": function($event) {
                _vm.selectedRequirement = requirement
              }
            }
          }, [_c('EditableText', {
            attrs: {
              "read-only": !_vm.editing,
              "plain": "",
              "inline": ""
            },
            on: {
              "change": function($event) {
                return _vm.savePolicy(policy, $event)
              }
            },
            model: {
              value: (requirement.description),
              callback: function($$v) {
                _vm.$set(requirement, "description", $$v)
              },
              expression: "requirement.description"
            }
          })], 1), _vm._v(" "), (_vm.editing) ? _c('div', {
            staticStyle: {
              "display": "inline",
              "margin": "0 -8px"
            }
          }, [_c('v-menu', {
            attrs: {
              "offset-y": "",
              "left": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "grey lighten-2"
                  }
                }, on), [_vm._v("more_vert")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.addRequirement(option)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("AND (another requirement)")])], 1), _vm._v(" "), _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.addOption(policy)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("OR (alternative requirements)")])], 1), _vm._v(" "), (option.requirements.length > 1) ? _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.deleteRequirement(requirement, option, policy)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("Delete Requirement")])], 1) : _vm._e(), _vm._v(" "), (option.requirements.length == 1 && policy._stipulation.options.length > 1) ? _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.deleteOption(policy, optionIndex)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("Delete Entire Option")])], 1) : _vm._e(), _vm._v(" "), (optionIndex) ? _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.makePreferredRequirement(option, policy)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("Make This the Preferred Option")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()])
        })], 2)
      }) : _vm._e(), _vm._v(" "), (_vm.lender && policy._stipulation._default) ? _c('div', {
        staticClass: "light-text small-text"
      }, [_vm._v("\n                * Not " + _vm._s(_vm.lender.name) + " specific. \n                "), (_vm.editing) ? _c('a', {
        attrs: {
          "href": ""
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.makeLenderRequirements(policy)
          }
        }
      }, [_vm._v("Specify")]) : _vm._e()]) : _vm._e()], 2)
    })], 2) : _vm._e()]
  }), _vm._v(" "), (_vm.canWrite(_vm.policiesDoc)) ? _c('v-btn', {
    on: {
      "click": _vm.saveAll
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "white-background pa-6 full-height",
    staticStyle: {
      "overflow-y": "auto"
    },
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [(_vm.lender && !_vm.selectedPolicy) ? [(_vm.editing) ? _c('FormControl', {
    attrs: {
      "value": _vm.lender,
      "schema": _vm.lenderSchema
    },
    on: {
      "input": _vm.updateLender
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('FormControl', {
    attrs: {
      "value": _vm.lender,
      "schema": _vm.lenderSchemaRO
    },
    on: {
      "input": _vm.updateLender
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.selectedPolicy) ? [_c('FormControl', {
    attrs: {
      "value": _vm.selectedPolicy,
      "schema": _vm.policySchema
    },
    on: {
      "input": _vm.updatePolicy
    }
  })] : _vm._e(), _vm._v(" "), (_vm.selectedPolicy && !_vm.selectedPolicy._stipulation._default) ? [_c('FormControl', {
    attrs: {
      "value": _vm.selectedPolicy._stipulation,
      "schema": _vm.stipulationSchema
    },
    on: {
      "input": _vm.updateStipulation
    }
  })] : _vm._e(), _vm._v(" "), (_vm.selectedRequirement) ? [_c('div', {
    staticClass: "section-heading mb-3"
  }, [_vm._v("Requirement")]), _vm._v(" "), _c('FormControl', {
    attrs: {
      "value": _vm.selectedRequirement,
      "schema": _vm.requirementSchema
    },
    on: {
      "input": _vm.updateRequirement
    }
  })] : _vm._e(), _vm._v(" "), (_vm.editing) ? [_c('Permissions', {
    attrs: {
      "document": _vm.policiesDoc
    }
  }), _vm._v(" "), _c('Permissions', {
    attrs: {
      "document": _vm.lenderStipulationsDoc,
      "label": "Lender Permissions"
    },
    on: {
      "change": _vm.saveLenderStipulations
    }
  })] : _vm._e()], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ec390d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dc/Policies.vue
// module id = 2518
// module chunks = 1